<template>
    <div class="container">
        <b-modal
            :model-value="modTermContr"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.contrato }}</label>
                        <p>{{ nroContrato }}</p>

                        <label>{{ labels.fecha }}</label>
                        <b-form-input
                            v-model="form.fechaTerminacion"
                            type="date"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.observacion }}</label>
                        <b-form-textarea v-model="form.observacion" rows="3" max-rows="6" class="reset-input"></b-form-textarea>

                        <label>{{ labels.defEstado }}</label>
                        <b-form-select
                            v-model="form.defEstado" class="reset-input"
                        >
                            <option value=""> {{ labels.select }} </option>
                            <option value="Anulado">Anular</option>
                            <option value="Finalizado">Finalizar</option>
                            <option value="Terminado">Terminar</option>
                        </b-form-select>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="terminarContrato()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato'; 

export default {
    name : 'ModTerminaContrato',
    props : {
        modTermContr: {
            type: Boolean,
            default: false
        },
        nroContrato: {
            type: Number
        }
    },
    data() {
        return {
            form : {
                fechaTerminacion : '',
                observacion : '',
                defEstado : '',
            }
        }
    },
    computed : {
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title : 'Terminar o anular',
                    close : 'Cerrar',
                    save : 'Guardar',
                    anular : 'Anular',
                    fecha : 'Fecha:',
                    observacion : 'Observaciones:',
                    defEstado : 'Definir estado:',
                    contrato : 'Contrato:',
                    select : 'Seleccione...',
                    formInfoTitle: "Cambiar estado del contrato",
                    formInfoSubtitle: "Completa la información y termina o anula el contrato." 
                }
            }else{
                return {
                    title : 'Terminate or cancel',
                    close : 'Close',
                    save : 'Save',
                    anular : 'Annular',
                    fecha : 'Date:',
                    observacion : 'Observations:',
                    defEstado : 'Define state:',
                    contrato : 'Contract:',
                    select : 'Select...',
                    formInfoTitle: "Change contract status",
                    formInfoSubtitle: "Complete the information and either finalize or cancel the contract."
                }
            }
        }
    },
    methods : {
        cierraModal(){
            this.form.fechaTerminacion = '' 
            this.form.observacion = ''
            this.form.defEstado = ''
            this.$emit('cierraModal',false) 
        },
        // anularContrato(){
        // console.log('anularContrato'); 
        // },
        terminarContrato(){

            const datosForm = {
                fechaTerm: this.form.fechaTerminacion, 
                observaciones: this.form.observacion, 
                nroContrato: this.nroContrato, 
                estado : this.form.defEstado
            };

            if (Object.values(datosForm).includes('')) { 
                return this.$toast.error('Campo(s) pendiente(s) por diligenciar'); 
            } 

            Contrato.terminarContrato(datosForm) 
            .then((res) => { 
                if (res.status === 200) { 
                    this.$toast.success(res.data.message); 
                    this.$router.push('terminacioncontrato'); 
                    location.reload(); 
                }
            })
            .catch((error) => { 
                if (error.response && error.response.data) { 
                    this.$toast.error(error.response.data.message);
                } else {
                    this.$toast.error('Error de conexión con el servidor');
                }
            });
        }
    }
}
</script>

<style>

</style>
